
export const saveConsultation = ( state, payload ) => {
    state.save = payload
}
